import { QueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { refresh } from '@/services';
import { UserStore } from '@/store/user';
import { getRefresh, getSession, setSession } from './auth';
// config
// import { HOST_API_KEY } from '../config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: `${import.meta.env.VITE_HOST_API_KEY}` });
export const axiosInstanceReservationNext = axios.create({
  baseURL: `${import.meta.env.VITE_HOST_API_RESERVATION_NEXT_KEY}`,
});

export const raykouApi = axios.create({
  baseURL: `${import.meta.env.VITE_HOST_API_RAYKOU_API}`,
});
export const ApiRayquazaApi = axios.create({
  baseURL: `${import.meta.env.VITE_HOST_API_KEY}/rayquaza`,
});
export const axiosInstanceServerless = axios.create({
  baseURL: `${import.meta.env.VITE_HOST_API_SERVERLESS_KEY}`,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const rr = getSession();
    config.headers.Authorization = `Bearer ${rr}`;
    return config;
  },
  async (err: any) => {
    const { config } = err;

    if (err.response.status === 401) {
      const refreshBody = getRefresh();
      const refreshToken = await refresh(refreshBody);
      await setSession(refreshToken);

      config.headers.Authorization = `Bearer ${refreshToken.token}`;
      return config;
    }
    return Promise.reject(err);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshBody = getRefresh();
        const { accessToken } = await refresh(refreshBody);
        await setSession({ accessToken, refreshToken: refreshBody ?? '' });

        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return await axiosInstance(originalRequest);
      } catch (refreshError) {
        if (refreshError.response.status === 401 || refreshError.response.status === 400) {
          UserStore.getState().logout();
        }
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export const setupInterceptors = async (token: string) => {
  // axiosInstance.interceptors.request.clear();
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 10,
    },
  },
});

export default axiosInstance;
